export default __webpack_public_path__ + "static/media/IMG_9994.365fca9e.jpeg";